import {
  GET_ORDER,
  GET_ORDERS,
  GET_ORDERS_ERROR,
  GET_ORDERS_SUCCESS,
  GET_ORDER_ERROR,
  GET_ORDER_HISTORY,
  GET_ORDER_HISTORY_SUCCESS,
  GET_ORDER_HISTORY_ERROR,
  GET_ORDER_SUCCESS,
  TOGGLE_ORDER_HISTORY_MODAL,
} from "./actionTypes";

const initialState = {
  // orders
  loadingOrders: false,
  loadingOrdersSuccess: false,
  loadingOrdersError: null,
  orders: {},
  // add order
  order: {},
  // get order
  getOrderLoading: false,
  getOrderError: null,
  getOrderSuccess: null,
  // order history
  orderHistory: {},
  loadingOrderHistory: false,
  loadingOrderHistorySuccess: false,
  loadingOrderHistoryError: null,
};

const orders = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORDERS:
      state = {
        ...state,
        loadingOrders: true,
        loadingOrdersSuccess: false,
        loadingOrdersError: null,
        orders: [],
        order: {},
      };
      break;
    case GET_ORDERS_SUCCESS:
      state = {
        ...state,
        loadingOrders: false,
        loadingOrdersSuccess: true,
        loadingOrdersError: null,
        orders: action.payload,
      };
      break;
    case GET_ORDERS_ERROR:
      state = {
        ...state,
        loadingOrdersError: action.payload,
        loadingOrders: false,
        loadingOrdersSuccess: false,
        orders: [],
      };
      break;
    case GET_ORDER:
      state = {
        ...state,
        order: {},
        getOrderLoading: true,
        getOrderSuccess: false,
        getOrderError: null,
      };
      break;
    case GET_ORDER_SUCCESS:
      state = {
        ...state,
        getOrderError: null,
        getOrderSuccess: true,
        getOrderLoading: false,
        order: action.payload,
      };
      break;
    case GET_ORDER_ERROR:
      state = {
        ...state,
        getOrderError: action.payload,
        getOrderLoading: false,
        getOrderSuccess: false,
      };
      break;
    case GET_ORDER_HISTORY:
      state = {
        ...state,
        orderHistory: {},
        loadingOrderHistory: true,
        loadingOrderHistorySuccess: false,
        loadingOrderHistoryError: null,
      };
      break;
    case GET_ORDER_HISTORY_SUCCESS:
      state = {
        ...state,
        loadingOrderHistoryError: null,
        loadingOrderHistorySuccess: true,
        loadingOrderHistory: false,
        orderHistory: action.payload,
      };
      break;
    case GET_ORDER_HISTORY_ERROR:
      state = {
        ...state,
        loadingOrderHistoryError: action.payload,
        loadingOrderHistory: false,
        loadingOrdersSuccess: false,
      };
      break;
    case TOGGLE_ORDER_HISTORY_MODAL:
      state = {
        ...state,
        orderHistory: {},
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default orders;
